import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useReportFilters = (year) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["reportFilters", year],
    async () => {
      const res = await makeAuthedRequest(`v1/reporting/filters/year/${year}`, {
        method: "GET",
      });

      if (!res.ok) throw new Error((await res.json()).message);
      return res.json();
    },
    {
      staleTime: 5 * 60 * 1000,
    }
  );
};
